import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { REQUEST_PASS_STATUS } from '../../constants/enum';

const StatusRenderer = (props) => {

	switch (props.data.id_status) {
		case REQUEST_PASS_STATUS.NEW:  //Nouveau
			return <div>
					<FontAwesomeIcon icon={faCircle} style={{ color: '#00b0f0', height: '10px', marginRight: '10px' }} />
					{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
				</div>;
		case REQUEST_PASS_STATUS.ON_GOING:  //En cours
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#ffc000', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.WAITING_CLIENT:
		case REQUEST_PASS_STATUS.WAITING_INTERN://En attente
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#7030a0', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.BLOCKED:  //Bloqué
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#7030a0', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.VALIDATED:  //Validé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#00b050', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>Dossier complet</span>}
			</div>;
		case REQUEST_PASS_STATUS.SENT:  //Devis émis
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#7030a0', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.SIGNED:  //Devis Signé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#00b050', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.ACCEPTED:  //Accord de principe émis
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#00b050', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.BILLED:  //Facturé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#a6a6a6', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.TERMINATED:  //Terminé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#a6a6a6', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.REFUSED:  //Refusé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#d01818', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		case REQUEST_PASS_STATUS.CANCELLED:  //Annulé
			return <div>
				<FontAwesomeIcon icon={faCircle} style={{ color: '#d01818', height: '10px', marginRight: '10px' }} />
				{(props.displayLabel || props.displayLabel === undefined) && <span style={{textTransform: 'uppercase', fontSize: '12px'}}>{props.data.status.libelle}</span>}
			</div>;
		default:
			return (<span>{props.value}</span>);
	}

};

export default StatusRenderer;
